enum BreadcrumbName {
  ContainerApp = 'ContainerApp',

  // Campaigns
  CampaignsLibrary = 'CampaignsLibrary',
  CampaignPage = 'CampaignPage',

  // Campaign Workflow
  CampaignHome = 'CampaignHome',
  CampaignBrief = 'CampaignBrief',
  CampaignConceptPlan = 'CampaignConceptPlan',
  CampaignLogic = 'CampaignLogic',
  CampaignInsights = 'CampaignInsights',
  CampaignAdSets = 'CampaignAdSets',
  CampaignAds = 'CampaignAds',

  // Creative Templates
  CreativeTemplatesLibrary = 'CreativeTemplatesLibrary',
  CreativeTemplatePage = 'CreativeTemplatePage',
  CreativeTemplateHomeTab = 'CreativeTemplateHomeTab',
  AdBuilder = 'AdBuilder',
  TemplateMapping = 'TemplateMapping',

  // Creatives
  CreativesLibrary = 'CreativesLibrary',
  CreativePage = 'CreativePage',

  // Analytics
  Dashboard = 'Dashboard',

  // Brand Guidelines Page
  BrandGuidelinesPage = 'BrandGuidelinesPage',
  BrandGuidelines = 'BrandGuidelines',
  BrandAssets = 'BrandAssets',
  BrandPersonas = 'BrandPersonas',

  // Target Platforms
  TargetPlatforms = 'TargetPlatforms',
  VideoSettings = 'VideoSettings',

  //Product Feeds Page
  ProductFeedPage = 'ProductFeedPage',
  CatalogFeedTab = 'CatalogFeedTab',
  // Content Feeds
  ContentFeedsLibrary = 'ContentFeedsLibrary',
  ContentFeedPage = 'ContentFeedPage',

  // DSP Library 2
  DspLibrary2 = 'DspLibrary2',
}

enum BreadcrumbDepthOrder {
  DeepestFirst = 'deepestFirst',
  ShallowestFirst = 'shallowestFirst',
}

export {BreadcrumbDepthOrder, BreadcrumbName};
